import { Shell } from "../components/Shell";
import { t } from "../i18n";

export default function Acerca() {
  return (
    <Shell title={t("about.title")} back="/ajustes" fab={false}>
      <div className="fade-up space-y-5 mt-6" data-testid="acerca-page">
        <div className="flex flex-col items-center gap-3">
          <span className="w-16 h-16 rounded-full border-[5px] border-[#d4af37]" aria-hidden />
          <h2 className="text-2xl font-medium">{t("app.title")}</h2>
          <p className="text-xs text-muted-foreground">{t("about.version")}</p>
        </div>
        <p className="text-sm text-center text-muted-foreground">{t("about.tagline")}</p>
        <div className="surface p-4 text-sm space-y-2">
          <p className="font-medium">{t("about.privacy")}</p>
          <p className="text-muted-foreground">{t("about.privacyText")}</p>
        </div>
        <p className="text-center text-xs text-muted-foreground pt-6">
          Powered by <a data-testid="namtech-link" href="https://www.namtech.mx" target="_blank" rel="noopener noreferrer" className="text-[#f3c649]">NAMTECH</a>
        </p>
      </div>
    </Shell>
  );
}
